import Swal from 'sweetalert2'

export default {
  install: (app) => {
    app.config.globalProperties.$loading = {
      show(text = 'Cargando...') {
        Swal.fire({
          title: '...',
          text: text,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          customClass: {
            popup: 'text-sm',   
            confirmButton: 'text-sm',
            cancelButton: 'text-sm'
          },
          didOpen: () => {
            Swal.showLoading()
          }
        })
      },
      close() {
        Swal.close()
      }
    }
  }
}


// cambiar didOpen para un custom : html: '<img src="/img/loader.gif" alt="Cargando..." />',